module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/products/products-bundles/products-bundles.component.scss
// module id = ./src/app/routes/products/products-bundles/products-bundles.component.scss
// module chunks = 9